import { Grid, Box, Container, Stack, Typography } from "@mui/material";
import KpiCard from "../../components/ui/kpiCard";
import Page from "../../components/Page";
import { RevenueKpis } from "./ui/revenu/revenueKpis";
import { RevenueEvolutionChart } from "./ui/revenu/RevenueEvolutionChart";
import { RevenuePaymentMethods } from "./ui/revenu/RevenuePaymentMethods";
import { RevenueTransactions } from "./ui/revenu/RevenueTransactions";



export default function Revenue() {
    return (
        <Page title="Analyse">
            <Container sx={{ marginTop: { xs: 3, sm: 0 } }}>
                <Stack spacing={5}>
                    <Box>
                        <Typography variant="h4">Revenus</Typography>
                        <Typography color={'text.secondary'} fontSize={16}>Analyse financière complète : revenus, marges, projections et comparaisons.</Typography>
                    </Box>
                    <Box>
                        <RevenueKpis />

                        <Grid container spacing={3}>
                            <Grid item xs={12} md={8}>
                                <RevenueEvolutionChart
                                    data={[
                                        { date: '01/01', amount: 120000 },
                                        { date: '05/01', amount: 350000 },
                                        { date: '10/01', amount: 780000 },
                                        { date: '15/01', amount: 1200000 },
                                    ]}
                                />
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <RevenuePaymentMethods
                                    data={[
                                        { method: 'Mobile Money', value: 60 },
                                        { method: 'Carte bancaire', value: 25 },
                                        { method: 'PayPal', value: 15 },
                                    ]}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <RevenueTransactions
                                    transactions={[
                                        {
                                            id: 1,
                                            date: '15/01/2026',
                                            amount: '25 000',
                                            method: 'Mobile Money',
                                            status: 'Succès',
                                        },
                                        {
                                            id: 2,
                                            date: '14/01/2026',
                                            amount: '10 000',
                                            method: 'Carte bancaire',
                                            status: 'Succès',
                                        },
                                    ]}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </Stack>

            </Container>

        </Page>

    );
}
